<template>
  <div class="suspend-anthor">
    <div class="anthor-header" @click="showSignedTeams = true">
      <img
        class="img"
        alt=""
        src="~@/assets/financialCompetition/sign-up-teams-2x.png"
      />
      已报名队伍
    </div>
    <div class="anthor-header" @click="showRankingList = true">
      <img
        class="img"
        alt=""
        src="~@/assets/financialCompetition/rank-list@2x.png"
      />
      排行榜
    </div>
    <div class="anthor-items">
      <div
        class="anthor-item"
        :class="{ active: activeAnther == item.name }"
        v-for="item in anthorItems"
        :key="item.name"
        @click="goPagePart(item.name)"
      >
        {{ item.label }}
      </div>
    </div>
    <div class="anthor-footer" v-show="showToTop">
      <span class="scroll-top" @click="scrollToUp">
        <span class="up-icon">
          <h-icon name="packup" class="icon"></h-icon>
        </span>
      </span>
    </div>
    <rankingList :show.sync="showRankingList"></rankingList>
    <SignedTeams v-model="showSignedTeams" />
  </div>
</template>

<script>
import rankingList from './rankingList/rankingList'
import SignedTeams from './MyTeam/SignedTeams'
import { bus } from '../config'

export default {
  name: 'SuspendAnthor',
  components: {
    rankingList,
    SignedTeams
  },
  props: {
    anthorOffset: {
      type: Number,
      default: 150
    }
  },
  data() {
    return {
      anthorItems: [
        {
          name: 'introduce',
          label: '大赛简介',
          animationId: '', // 模块id【首次展现时动画需要获取相应的模块】
          hasShow: false // 是否展示过，初次展示则进行动画
        },
        {
          name: 'round',
          label: '当前赛事',
          animationId: '#coupete-round',
          hasShow: false
        },
        {
          name: 'questions',
          label: '赛题参考',
          animationId: '#competition-questions',
          animationId1: '#competition-questions1',
          hasShow: false
        },
        {
          name: 'bigShots',
          label: '大咖助阵',
          animationId: '#big-shot',
          animationId1: '#big-shot1',
          hasShow: false
        },
        {
          name: 'award',
          label: '大赛奖励',
          animationId: '#compete-award',
          animationId1: '#compete-award1',
          hasShow: false
        },
        {
          name: 'rules',
          label: '赛事规则',
          animationId: '#compete-rule',
          animationId1: '#compete-rule1',
          hasShow: false
        }
      ],
      activeAnther: '',
      showSignedTeams: false, // 展示已报名队伍
      showRankingList: false, // 展示排行榜
      competeProgress: false,
      scrollTop: 0,
      showToTop: false,
      delayTimer: null
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('scroll', this.handleScroll)
    })
    bus.$on('showRankList', () => {
      this.showRankingList = true
    })
  },
  destroyed() {
    window.removeEventListener('scroll', this.handleScroll)
    if (this.delayTimer) {
      clearTimeout(this.delayTimer)
      this.delayTimer = null
    }
  },
  methods: {
    // 处理挂件列表点击
    handleItemClick(list) {
      window.open(list.url)
    },
    viewCompeteChart() {
      this.showCompeteChart = true
    },
    goPagePart(name) {
      this.activeAnther = name
      const diff = name === 'introduce' ? -35 : 0
      if (this.scrollTop >= this.$parent.$refs[name].offsetTop + diff) {
        this.procPageScroll(this.$parent.$refs[name].offsetTop + diff, 'top')
      } else {
        this.procPageScroll(this.$parent.$refs[name].offsetTop + diff, 'down')
      }
    },
    scrollToUp() {
      this.procPageScroll(0, 'top')
    },
    procPageScroll(toPosition, type) {
      try {
        if (this.isIE()) {
          throw new Error('')
        } else {
          window.scrollTo({ top: toPosition, behavior: 'smooth' })
        }
      } catch (e) {
        if (type === 'down') {
          this.manualScrollDown(toPosition)
        } else {
          this.manualScrollUp(toPosition)
        }
      }
    },
    manualScrollUp(targetPos) {
      let top = this.scrollTop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top -= 50
        if (top <= targetPos) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    manualScrollDown(targetPos) {
      let top = this.scrollTop
      const timeTop = setInterval(() => {
        document.body.scrollTop = document.documentElement.scrollTop = top += 50
        if (top >= targetPos) {
          clearInterval(timeTop)
        }
      }, 10)
    },
    handleScroll() {
      this.scrollTop =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        document.body.scrollTop
      this.showToTop = this.scrollTop > 0
      if (this.delayTimer) clearTimeout(this.delayTimer)
      this.delayTimer = setTimeout(() => {
        this.scrollPageAnimate()
        this.scrollCheckActivePagePart()
        clearTimeout(this.delayTimer)
        this.delayTimer = null
      }, 50)
    },
    // 滚动的时候计算各个模块是否需要进行展示动画
    scrollPageAnimate() {
      const winHeight = document.body.clientHeight
      for (var index = this.anthorItems.length - 1; index >= 0; index--) {
        const curModuleName = this.anthorItems[index].name
        const curModuleId = this.anthorItems[index].animationId
        const curModuleId1 = this.anthorItems[index].animationId1
        // 如果滚动到某个模块的时候，将该模块进行动画展示
        if (
          !this.anthorItems[index].hasShow &&
          curModuleId &&
          this.$parent.$refs[curModuleName].offsetTop - winHeight <
            this.scrollTop - 30
        ) {
          this.animateCSS(curModuleId, 'fadeInUp').then(() => {
            document.querySelector(curModuleId).style.opacity = '1'
          })
          curModuleId1 &&
            this.animateCSS(curModuleId1, 'fadeInUp').then(() => {
              document.querySelector(curModuleId1).style.opacity = '1'
            })
          this.anthorItems[index].hasShow = true
        }
      }
    },
    scrollCheckActivePagePart() {
      for (var index = this.anthorItems.length - 1; index >= 0; index--) {
        const curModuleName = this.anthorItems[index].name
        if (
          curModuleName !== 'news' &&
          this.$parent.$refs[curModuleName].offsetTop <=
            this.scrollTop + this.anthorOffset
        ) {
          this.activeAnther = this.anthorItems[index].name
          return
        }
      }
      this.activeAnther = ''
    },
    isIE() {
      const userAgent = navigator.userAgent.toLocaleLowerCase()
      const ie11reg = /(trident)\/([\d.]+)/
      if (
        (userAgent.indexOf('compatible') > -1 &&
          userAgent.indexOf('msie') > -1) ||
        userAgent.match(ie11reg)
      ) {
        return true
      }
      return false
    }
  }
}
</script>

<style lang="scss" scoped>
.suspend-anthor {
  position: fixed;
  right: 20px;
  bottom: 100px;
  z-index: 20;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 146px;
  .anthor-header {
    width: inherit;
    margin-top: 15px;
    height: 40px;
    line-height: 40px;
    background-color: #3060ff;
    background-image: linear-gradient(42deg, #3060ff 0%, #5db7ff 100%);
    border-radius: 20px;
    box-sizing: border-box;
    padding-left: 40px;
    font-family: 'PingFangSC-Medium', Arial, 'Microsoft Yahei', sans-serif,
      Verdana, 'PingFang SC';
    font-size: 12px;
    color: #ffffff;
    position: relative;
    text-align: center;
    cursor: pointer;
    .img {
      display: inline-block;
      width: 48px;
      height: 48px;
      background: #5db7ff;
      border-radius: 50%;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
    &.team-chart {
      width: 150px;
    }
  }
  .anthor-items {
    width: inherit;
    margin-top: 24px;
    background: #fff;
    box-shadow: 0 0 15px 0 #e6e6e6;
    border-radius: 4px;
    padding: 8px 0;
    .anthor-item {
      font-family: 'PingFangSC-Regular', Arial, 'Microsoft Yahei', sans-serif,
        Verdana, 'PingFang SC';
      font-size: 14px;
      color: #333333;
      text-align: center;
      width: 100%;
      height: 40px;
      line-height: 40px;
      text-align: center;
      cursor: pointer;
      &:hover {
        background-color: #f6f6f6;
      }
      &.active {
        background: rgba(16, 56, 253, 0.08);
        color: #1038fd;
      }
    }
  }
  .anthor-footer {
    width: inherit;
    display: flex;
    justify-content: center;
    position: relative;
    .scroll-top {
      display: inline-flex;
      justify-content: center;
      align-items: center;
      height: 40px;
      width: 40px;
      background: #fff;
      border-radius: 50%;
      box-shadow: 0 0 15px 0 #e6e6e6;
      cursor: pointer;
      position: absolute;
      top: 32px;
      .up-icon {
        font-size: 14px;
        position: relative;
        &::after {
          display: inline-block;
          content: '';
          width: 16px;
          height: 2px;
          background: #4d4d4d;
          position: absolute;
          left: 50%;
          transform: translateX(-50%) translateY(11px);
        }
        .icon {
          color: #333;
          font-size: 24px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/gtn/views/financialCompetitionViews/components/suspendAnthor.vue